import PickerDropdown from "@pathwright/ui/src/components/picker/PickerDropdown"
import withLibraryPicker from "./withLibraryPicker"

export default withLibraryPicker(PickerDropdown)
